import appConfig from '../../data/login.env';

export const captchaOperators = ['+', '-', '*', '/'];

export const loginFieldType = {
    _userlogin_: 'username',
    _userpwd_: 'userpassword',
    _voucheruid_: 'voucheruuid',
    _useremail_: 'useremail',
    _forgetanswer_: 'forgetanswer'
};

export const _loginErrorType = {
    noUserLogin: {
        msg: 'Please enter your login ID',
        fields: [loginFieldType._userlogin_]
    },
    noUserEmail: {
        msg: 'Please enter your email address',
        fields: [loginFieldType._useremail_]
    },
    noPwd: {
        msg: 'Please enter your password',
        fields: [loginFieldType._userpwd_]
    },
    noCredentials: {
        msg: 'Please enter your login ID/password',
        fields: [loginFieldType._userlogin_, loginFieldType._userpwd_]
    },
    noVoucheruid: {
        msg: 'Please fill the voucher code',
        fields: [loginFieldType._voucheruid_]
    },
    noAnswer: {
        msg: 'Please fill the answer',
        fields: [loginFieldType._forgetanswer_]
    },
    badAnswer: {
        msg: 'Incorrect result',
        fields: [loginFieldType._forgetanswer_]
    }
};

export function validateCredentials(username, password) {
    const isUserNameEmpty = !username || username.trim().length === 0;
    const isPwdEmpty = !password || password.trim().length === 0;

    if (isUserNameEmpty && isPwdEmpty) {
        return _loginErrorType.noCredentials;
    } else if (isUserNameEmpty) {
        return _loginErrorType.noUserLogin;
    } else if (isPwdEmpty) {
        return _loginErrorType.noPwd;
    }
    return {};
}

export function getCaptchaResult(captchaOptions) {
    const {captchaL, captchaR, captchaOperator} = captchaOptions;
    if (captchaOperator === '*') {
        return captchaL * captchaR;
    } else if (captchaOperator === '+') {
        return captchaL + captchaR;
    } else if (captchaOperator === '/') {
        return captchaL / captchaR;
    }
    return captchaL - captchaR;
}

export function validateForgetSubmit(activeTab, field, answer, captchaOptions) {
    const isFieldEmpty = !field || field.trim().length === 0;
    if (isFieldEmpty) {
        return activeTab === 'pwd'
            ? _loginErrorType.noUserLogin
            : _loginErrorType.noUserEmail;
    }
    const isAnswerEmpty = !answer || answer.trim().length === 0;
    if (isAnswerEmpty) {
        return _loginErrorType.noAnswer;
    }
    const rightAnswer = getCaptchaResult(captchaOptions);
    if (parseInt(answer, 10) !== rightAnswer) {
        return _loginErrorType.badAnswer;
    }

    return {};
}

export function isVoucherEmpty(voucheruid) {
    if (!voucheruid || voucheruid.trim().length === 0) {
        return _loginErrorType.noVoucheruid;
    }
    return {};
}

export function getRegistrerVoucherUrl(baseUrl, voucheruuid) {
    const {
        controllerUrl,
        actionParam,
        initActionParam,
        uuidParam
    } = appConfig.voucherSettings;
    return `${baseUrl}/${controllerUrl}?${actionParam}=voucher_auth&${uuidParam}=${voucheruuid}&${initActionParam}=true`;
}

/**
 * @returns create 3DEx id url
 * @description reuse register voucher process with special voucher id
 * @param {*} baseUrl
 */
export function getCreate3DExIdUrl(baseUrl) {
    const {
        controllerUrl,
        actionParam,
        initActionParam,
        uuidParam
    } = appConfig.voucherSettings;
    return `${baseUrl}/${controllerUrl}?${actionParam}=voucher_auth&${uuidParam}=ext&${initActionParam}=true`;
}

export function getRedirectionUrl(baseUrl, result) {
    switch (result) {
        case 'successAdmin':
            return `${baseUrl}/${appConfig.clsUrls.adminUrl}`;
        case 'successStudent':
            return `${baseUrl}/${appConfig.clsUrls.studentUrl}`;
        case 'successTeacher':
            return `${baseUrl}/${appConfig.clsUrls.teacherUrl}`;
        case 'successAuthor':
            return `${baseUrl}/${appConfig.clsUrls.authorUrl}`;
        case 'CATCmaTermsofUse':
            return `${baseUrl}/${appConfig.clsUrls.termOfUseUrl}`;
        case 'changePassword':
            return `${baseUrl}/${appConfig.clsUrls.changePwdUrl}`;
        case 'CATCmaStudentTrainingPlan':
            return `${baseUrl}/${appConfig.clsUrls.assignmentUrl}`;
        case 'CATCmaInAccessibleLinkPage':
            return `${baseUrl}/${appConfig.clsUrls.inAccessibleLinkUrl}`;
        case 'downloadCourseDocumentsPage':
            return `${baseUrl}/${appConfig.clsUrls.coursewareDownloadUrl}`;
        case 'errorLink':
            return `${baseUrl}/${appConfig.clsUrls.errorLink}`;
        case 'pdfDownload':
            return `${baseUrl}/${appConfig.clsUrls.pdfDownload}`;
        default:
            return '';
    }
}

/**
 * @ngdoc method
 * @name getDivisors
 * @methodOf cls.captchaUtility
 * @description gets the operator and operands for captcha
 * @param {int} n number for which divisor will be returned
 * @return {int} return the divisor of the number
 */
function getDivisors(n) {
    if (n < 1) {
        n = 0;
    }
    const small = [];
    const large = [];
    const end = Math.floor(Math.sqrt(n));
    for (let i = 1; i <= end; i++) {
        if (n % i === 0) {
            small.push(i);
            if (i * i !== n) {
                large.push(n / i);
            }
        }
    }
    large.reverse();
    return small.concat(large);
}

export function getOperations() {
    let captchaL, captchaR, num;
    const operator =
        captchaOperators[Math.floor(Math.random() * captchaOperators.length)];
    captchaL = Math.floor(Math.random() * (16 - 6) + 6);
    if (operator === '/') {
        num = getDivisors(captchaL);
        captchaR = num[Math.floor(Math.random() * num.length)];
    } else {
        captchaR = Math.floor(Math.random() * 5 + 1);
        while (captchaL < captchaR) {
            captchaL = Math.floor(Math.random() * 15);
            captchaR = Math.floor(Math.random() * 5 + 1);
        }
    }
    return {
        captchaL,
        captchaR,
        captchaOperator: operator
    };
}

export function getSearchParams(search) {
    if (window.location.hash.split('#/').length <= 1) {
        return {};
    }
    const searchParams = {};

    try {
        const searchArray = window.location.hash
            .replace(/^#\/\?/, '')
            .split('&');
        searchArray.forEach((pair) => {
            const params = pair.split('=');
            searchParams[params[0]] = params[1];
        });
        return searchParams;
    } catch (err) {
        console.log(err);
        return {};
    }
}
